import React, { useState } from "react";

const VideoStreaming = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const videos = [
    { id: 1, name: "User 1", main: true, src: "../video/1.mp4" },
    { id: 2, name: "User 2", main: false, src: "../video/2.mp4" },
    { id: 3, name: "User 3", main: false, src: "../video/3.mp4" },
    { id: 4, name: "User 4", main: false, src: "../video/4.mp4" },
  ];

  return (
    <div className="flex flex-col items-center min-h-screen p-4">
      {/* Main Video Section */}
      {selectedVideo && (
        <div className="relative w-full max-w-4xl rounded-lg shadow-lg p-4 mb-6">
          <div className="relative">
            <video
              controls
              autoPlay
              className="w-full bg-gray-700 rounded-lg aspect-video"
              src={selectedVideo.src}
            />
            <button
              onClick={() => setSelectedVideo(null)}
              className="absolute top-2 right-2 bg-red-500 text-white text-2xl font-bold p-2 rounded-full hover:bg-red-600 transition-colors"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* Circular Video Cards */}
      <div className="grid grid-cols-3 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {videos
          .filter((video) => video.id !== (selectedVideo?.id || null)) // Hide selected video
          .map((video) => (
            <div
              key={video.id}
              onClick={() => setSelectedVideo(video)}
              className={`relative cursor-pointer w-36 h-36 flex items-center justify-center rounded-full border-4 transition-shadow ${video.main
                ? "border-green-500 shadow-lg shadow-green-500"
                : "border-gray-400"
                } hover:shadow-lg hover:shadow-gray-500`}
            >
              <video
                className="w-full h-full rounded-full object-cover"
                muted
                loop
                src={video.src}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default VideoStreaming;
